import { useContext } from "react";
import { SWRResponse } from "swr";
import { MerkOperatorContactResponse } from "@letsbit/malcolmlb";
import { ApiContext } from "providers/ApiProvider";
import { useAuthSWR } from "hooks/utils/useAuthSWR";

export const SWR_GET_OPERATOR_CONTACT_KEY = "get-operator-contact-key";

export const useGetOperatorContact =
  (): SWRResponse<MerkOperatorContactResponse> => {
    const { memberInstance } = useContext(ApiContext);

    const swr = useAuthSWR(SWR_GET_OPERATOR_CONTACT_KEY, async () => {
      const { data } = await memberInstance.merk.getOperatorContact();
      return data;
    });

    return swr;
  };
